// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2ga6O","inputWrap":"styles_inputWrap__3ZxaS","input":"styles_input__lIkLq"};